<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col sm="12">
      <transition name="slide">
      <b-card body-class="pt-1">
        <div slot="header">
          <div class="row pl-2 pr-2">
            <b-col sm="12" lg="9" class="pt-2 p-1 title">
              <span :title="corporationSelected && corporationSelected.name">Grupos de Usuários - {{corporationSelected && corporationSelected.name}}</span>
            </b-col>
            <b-col sm="12" lg="2" class="input-group input-group-sm p-1">
              <input class="form-control input-txt" id="txt-search" type="text" name="txt-search" v-model="filters.text" v-on:keyup.enter="search">
              <span class="input-group-append">
                <button id="btn-search" class="btn btn-success" type="button" title="Buscar" @click="search" @click.stop.prevent>
                  <i class="fa fa-search"></i>
                </button>
              </span>
            </b-col>
            <b-col sm="12" lg="1" class="p-1">
              <b-button type="button" size="sm" title="Novo grupo" variant="success" class="btn-novo form-control" @click="groupNew">Novo</b-button>
            </b-col>
          </div>
        </div>
        <p class="lbl-filtro-descricao" v-if="filterDescription">
          <small class="text-muted" id="lbl-info">
            <i class="fa fa-filter"></i> {{ filterDescription }}
          </small>
        </p>
        <b-table :hover="true" :striped="true" :bordered="false" :small="false" :fixed="false" responsive="sm" 
          :items="items" :fields="fields" @row-clicked="rowClicked">
          <template slot="actions" slot-scope="data">
            <b-button type="button" title="Excluir" size="sm" variant="danger" @click="deleteGroup(data.item.id)">
              <i class="fa fa-trash fa-lg"></i>
            </b-button>
          </template>
        </b-table>
        <nav>
          <b-pagination size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @change="paginationChanged" prev-text="<<" next-text=">>" hide-goto-end-buttons/>
        </nav>
      </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env, formatDate } from '@/shared/utils';
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'UserGroups',
  components: {
    Loading
  },
  data: () => {
    return {
      items: [],
      fields: [
        {key: 'name', label: 'Nome'},
        {key: 'actions', label: 'Ações'}
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      itemsByPage: {},
      filters: {
        text: null,
      },
      filterDescription: null,
      loadCount: 0,
    }
  },
  mounted() {
    this.getGroups();
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    },
    ...mapState(['corporationSelected'])
  },
  watch: {
    async corporationSelected(corporation) {
      this.itemsByPage = {};
      await this.getGroups();
    }
  },
  methods: {
    deleteGroup(id) {
      this.$bvModal.msgBoxConfirm('Deseja realmente excluir o grupo?', {
        okVariant: 'danger',
        okTitle: 'Sim',
        cancelTitle: 'Não',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
          if (value) {
            this.loadCount++;
            axios
              .delete(`${env.urlBillingApi}/user-group/${id}`)
              .then((response) => {
                this.itemsByPage = {};
                this.getGroups();
              })
              .catch((error) => {
                requestError(error);
              })
              .finally(() => {
                this.loadCount--;
              });
          }
        })
        .catch(console.log);
    },
    rowClicked (item) {
      this.$router.push({path: `user-groups/edit/${item.id}`})
    },
    groupNew () {
      this.$router.push('user-groups/new');
    },
    paginationChanged (pageNumber) {
      this.getGroups(pageNumber);
    },
    search () {
      this.getGroups(1);
    },
    getGroups (page = 1) {
      var cacheKey = JSON.stringify(this.filters) + page;
      if (this.itemsByPage[cacheKey]) {
        this.items = this.itemsByPage[cacheKey];
        this.currentPage = page;
        return;
      }
      this.setFilterDescription();
      let urlParams = this.prepareParams(page);
      var _this = this;
      this.loadCount++;
      axios
        .get(`${env.urlBillingApi}/user-group?${urlParams}`)
        .then(function(response) {
          _this.items = response.data._embedded.user_group;
          _this.currentPage = Math.max(response.data.page, 1);
          _this.itemsByPage[JSON.stringify(_this.filters) + _this.currentPage] = _this.items;
          _this.perPage = response.data.page_size;
          _this.totalRows = response.data.total_items;
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    prepareParams(page) {
      let urlParam = `page=${page}`;
      if (this.filters.text) {
        urlParam += `&search=${this.filters.text}`;
      }
      return urlParam;
    },
    setFilterDescription() {
      let desc = [];
      if (this.filters.text) {
        desc.push(this.filters.text)
      }
      this.filterDescription = desc.join(', ');
    }

  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.search-area {
  max-width: 280px;
}
.input-txt {
  height: 32px !important;
}
.title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

@media screen and (max-width: 468px) {
  .title {
    text-align: center;
  }
}
</style>
